export const restoreCurrentSession = async ({ fetchSession, applySession, failAuthentication }) => {
  const response = await fetchSession()
  const session = response.data.result
  if (!session || !session.user) {
    const error = new Error('The authenticated user session could not be restored.')
    error.code = 'AUTH_SESSION_NOT_FOUND'
    await failAuthentication()
    throw error
  }
  applySession(session)
  return session
}



// WEBPACK FOOTER //
// ./src/auth/currentSession.js